module.exports = __webpack_public_path__ + "static/bottom-bb1544d25a12db40bc0c40eea627345b.png";